import { Alert, AlertTitle } from '@mui/material';
import { PropsWithChildren, useCallback } from 'react';
import { Cafe } from '../../../apiTypes';
import { t } from '../../../constants/translations';
import { useAdmin } from '../../../contexts/admin.context';
import { useLocale } from '../../../contexts/locale.context';
import { updateDoc } from '../../../utils/api';
import PrimaryButton from '../../PrimaryButton';

type Props = {
  number: string;
};

const Step = ({ number, children }: PropsWithChildren<Props>) => {
  const { lang } = useLocale();
  const { cafeSlug } = useAdmin();

  const handleDone = useCallback(() => {
    updateDoc<Cafe>(`cafes/${cafeSlug}`, {
      [`messages.step${number}`]: true,
    });
  }, [cafeSlug, number]);

  return (
    <Alert severity="info" color="warning" sx={{ mb: 2 }} onClose={handleDone}>
      <AlertTitle>{`${t.step[lang]} ${number}`} </AlertTitle>

      {children}

      <PrimaryButton size="small" variant="contained" onClick={handleDone} sx={{ mt: 2 }}>
        {t.done[lang]}
      </PrimaryButton>
    </Alert>
  );
};

export default Step;
